import { RouteUrlList } from '@/libs/RouteList';
/**
 * @todo 取得停登訊息
 */
const GetAlertMessage = [
    'POST',
    RouteUrlList.API_ServiceAlert.path,
    {},
    200,
    {
        requestToken: null,
        isShowAlertMessage: false,
        alertId: '14e66f70811911587774fc33aa8d356b5fcd344f7a391b246c42c39fcf7d2c27',
        alertType: 0, // 1
        alertTitle: '123',
        alertMessage: '',
        idleTimeoutHintMinutes: 9,
        status: true,
        title: 'qwe',
        message: '123',
        errorCode: null
    }
];
export default GetAlertMessage;
